import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment";
import { withRouter } from "react-router";

//Utilities
import Utility from "../Utils/Utility";

//Constants
import { DATE_FORMAT, LOAN_CATEGORY_LEGEND } from "../Utils/Constants";

//Styles
import "./LoanApplicationList.scss";

//Assets
import LoanImage from "../Assets/images/ic_loan.svg";

class LoanApplicationCard extends Component {
  /**
   * This function will get called when cashier clicks on loan application card.
   */
  handleOnClickLoanApplicationCard = (applicationId) => {
    this.props.handleOnClickLoanApplicationCard(applicationId);
  };

  render() {
    const fullName =
      this.props.loanApplicationData.firstName +
      " " +
      this.props.loanApplicationData.lastName1 +
      " " +
      this.props.loanApplicationData.lastName2;
    let categoryBorder = this.props.loanApplicationData.category
      ? {
          padding: "5px",
          borderRadius: "50%",
          border: ` 2px solid ${
            LOAN_CATEGORY_LEGEND[
              LOAN_CATEGORY_LEGEND.findIndex((legendType) => {
                return (
                  legendType.value === this.props.loanApplicationData.category
                );
              })
            ].color
          }`,
        }
      : {};

    return (
      <div
        className={
          this.props.loanApplicationData.highlight
            ? "loanApplicationCard clickableArea"
            : "loanApplicationCard paddingTop clickableArea"
        }
        onClick={() =>
          this.handleOnClickLoanApplicationCard(
            this.props.loanApplicationData.applicationId
          )
        }
      >
        <Row
          className={
            this.props.loanApplicationData.highlight
              ? "text-right"
              : "clockIcon"
          }
          title="48 horas pasadas"
        >
          {this.props.loanApplicationData.highlight && (
            <i className="fa fa-clock-o clockIcon" />
          )}
        </Row>
        <Row md={12}>
          <Col md={3}>
            <div style={categoryBorder}>
              <img
                src={LoanImage}
                className="applicantImage text-center"
                alt="loanImage"
              />
            </div>
            <div className="applicationId">
              <span title="ID de Aplicación">
                {this.props.loanApplicationData.applicationId}
              </span>
            </div>
          </Col>

          <Col md={9}>
            <Row className="loanDetails" title="Monto">
              &euro;&nbsp;
              {Utility.getCurrencyRepresentationOfAmount(
                this.props.loanApplicationData.amount
              )}
            </Row>
            <Row className="loanDetails applicantName" title="Nombre Completo">
              {fullName}
            </Row>

            <Row md={12} className="loanDetails" title={"Fecha de desembolso"}>
              <Col md={8} className="disbursementDateTime noPadding ">
                {this.props.loanApplicationData.disbursementDate
                  ? moment(
                      this.props.loanApplicationData.disbursementDate
                    ).format(DATE_FORMAT)
                  : "No Desembolsada"}
              </Col>
            </Row>
            <Row className="loanDetails" title={`EMI (Fecha de Vencimiento)`}>
              &euro;&nbsp;
              {this.props.loanApplicationData.maturityDate
                ? `${Utility.getCurrencyRepresentationOfAmount(
                    this.props.loanApplicationData.emi
                  )} (${moment(
                    this.props.loanApplicationData.maturityDate
                  ).format(DATE_FORMAT)})`
                : `${Utility.getCurrencyRepresentationOfAmount(
                    this.props.loanApplicationData.emi
                  )} (N / A)`}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(LoanApplicationCard);
